import { Mail, Phone, MapPin } from "lucide-react";
import { SEO } from "@/components/SEO";
import { Breadcrumbs } from "@/components/Breadcrumbs";
import { ContactMap } from "@/components/contact/ContactMap";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

const ContactUs = () => {
  console.log('Rendering ContactUs page');
  
  return (
    <>
      <SEO 
        title="Contact Us | Home Pros OKC"
        description="Get in touch with Home Pros OKC for inquiries, support, or feedback. We're here to help homeowners and contractors connect in Oklahoma City."
      />
      
      <div className="container mx-auto px-4 py-8">
        <Breadcrumbs items={[{ label: "Contact" }]} />
        
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-12">
            <h1 className="text-4xl font-bold mb-4">We'd Love to Hear From You!</h1>
            <p className="text-lg text-muted-foreground">
              Have questions, feedback, or need assistance? Our team is here to help. 
              Reach out to us directly for any inquiries, error reporting, or contractor suggestions.
            </p>
          </div>
          
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 mb-12">
            <div className="bg-primary/5 p-8 rounded-lg space-y-6">
              <div className="flex items-center space-x-4">
                <Mail className="h-6 w-6 text-primary" />
                <div>
                  <h3 className="font-semibold">Email Us</h3>
                  <a href="mailto:support@homeprosokc.com" className="text-primary hover:underline">
                    support@homeprosokc.com
                  </a>
                </div>
              </div>
              
              <div className="flex items-center space-x-4">
                <Phone className="h-6 w-6 text-primary" />
                <div>
                  <h3 className="font-semibold">Call Us</h3>
                  <a href="tel:+14059726779" className="text-primary hover:underline">
                    (405) 972-6779
                  </a>
                </div>
              </div>
              
              <div className="flex items-center space-x-4">
                <MapPin className="h-6 w-6 text-primary" />
                <div>
                  <h3 className="font-semibold">Service Area</h3>
                  <p>Serving Homeowners and Contractors Across OKC</p>
                </div>
              </div>
            </div>
            
            <ContactMap />
          </div>
          
          <div className="text-center bg-gradient-to-r from-primary/5 to-primary/10 p-12 rounded-lg">
            <h2 className="text-2xl font-bold mb-6">
              Ready to Get Started? Let's Make Your Next Home Project a Success!
            </h2>
            <div className="flex flex-col sm:flex-row justify-center gap-4">
              <Button asChild size="lg" className="bg-primary text-primary-foreground hover:bg-primary/90">
                <Link to="/for-pros">Get Listed Today</Link>
              </Button>
              <Button asChild size="lg" className="bg-primary text-primary-foreground hover:bg-primary/90">
                <a href="tel:+14059726779">Call to Get Connected with a Pro</a>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ContactUs;